import { configureStore } from '@reduxjs/toolkit';
import apiConfigReducer from './reducers/apiConfigReducer';
import brandGroupConfigReducer from './reducers/brandGroupConfigReducer';
import userReducer from './reducers/userReducer';
import validationPropertiesReducer from './reducers/validationPropertiesReducer';
import contextReducer from './reducers/contextReducer';
import countryConfigReducer from './reducers/countryConfigReducer';
import registrationFlowOrchestrationReducer from './reducers/registrationFlowOrchestrationReducer';

// Additional reducers can be added below
export const store = configureStore({
  reducer: {
    apiConfig: apiConfigReducer,
    brandGroupConfig: brandGroupConfigReducer,
    user: userReducer,
    validationProperties: validationPropertiesReducer,
    context: contextReducer,
    countryConfig: countryConfigReducer,
    registrationFlowOrchestration: registrationFlowOrchestrationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
